// Vendor Libs
import React, {useState} from 'react';
import PropTypes from 'prop-types';

// Material UI
import {makeStyles} from '@material-ui/core/styles';

// Components
import presets from './layout-presets';

// Contexts
import {LayoutContext} from '../../../contexts/layout-context';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
    },
});

const initialConfig = presets.createDefaultLayout();

const Root = ({className, component: Component, children, config, ...props}) => {
    const classes = useStyles();
    const [open, setOpen] = useState(true);
    const [collapsed, setCollapsed] = useState(false);

    const {
        clipped,
        collapsible,
        collapsedWidth,
        navVariant,
        navWidth,
        navAnchor,
        headerPosition,
        squeezed,
        footerShrink,
    } = config;

    const value = {
        open,
        setOpen,
        collapsed,
        setCollapsed,
        clipped,
        collapsible,
        collapsedWidth,
        navVariant,
        navWidth,
        navAnchor,
        headerPosition,
        squeezed,
        footerShrink,
        // screen: width,
    };

    return (
        <LayoutContext.Provider value={value}>
            <Component className={`${className} ${classes.root}`} {...props}>
                {typeof children === 'function' ? children(value) : children}
            </Component>
        </LayoutContext.Provider>
    );
};

Root.propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
    className: PropTypes.string,
    component: PropTypes.elementType,
    config: PropTypes.shape({
        clipped: PropTypes.bool,
        collapsed: PropTypes.bool,
        collapsedWidth: PropTypes.number,
        collapsible: PropTypes.bool,
        footerShrink: PropTypes.bool,
        headerPosition: PropTypes.oneOf(['static', 'relative', 'sticky', 'fixed', 'absolute']),
        navAnchor: PropTypes.oneOf(['left', 'bottom']),
        navVariant: PropTypes.oneOf(['permanent', 'persistent', 'temporary']),
        navWidth: PropTypes.number,
        squeezed: PropTypes.bool,
    }),
    // width: PropTypes.string.isRequired,
};

Root.defaultProps = {
    className: '',
    component: 'div',
    config: initialConfig,
};

export default Root;
